var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMobileApp = function SvgMobileApp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#FF3D3D",
    rx: 14.222
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#mobile-app_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M42.392 21.362c2.759 3.614 5.885 7.71 6.4 14.246 0 0 .097 1.277.097 1.732 0 9.047-7.55 16.41-16.84 16.436h-.011a.1.1 0 0 1-.031 0H32c-9.312 0-16.889-7.373-16.889-16.436 0-.311.001-.622.02-.933.244-8.265 4.302-11.003 5.364-11.586.122-.067.283.009.326.142.379 1.175 2.095 5.864 5.304 6.745a.2.2 0 0 0 .25-.196c.021-2.396.153-5.888.962-9.006 1.17-4.496 4.842-9.995 9.348-12.252.202-.101.436.051.447.279.195 4.06 2.801 7.607 5.258 10.826zm-11.81 25.495c-3.218 0-5.82-2.33-5.82-5.225 0-2.695 1.898-4.592 5.078-5.191 2.657-.499 5.386-1.547 7.284-3.195.988-.858 1.027-1.174 1.481.383.416 1.697.633 3.46.633 5.241.018 4.41-3.867 7.987-8.657 7.987",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "mobile-app_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.111 10.222H48.89v43.556H15.111z"
  })))));
};
export default SvgMobileApp;